import { render, staticRenderFns } from "./DanaGetAuthPopup.vue?vue&type=template&id=46dde497&scoped=true&"
import script from "./DanaGetAuthPopup.vue?vue&type=script&lang=js&"
export * from "./DanaGetAuthPopup.vue?vue&type=script&lang=js&"
import style0 from "./DanaGetAuthPopup.vue?vue&type=style&index=0&id=46dde497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dde497",
  null
  
)

component.options.__file = "DanaGetAuthPopup.vue"
export default component.exports